import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./ellipsisRemasteredDeluxe.scss";

export default class EllipsisRemasteredDeluxe extends Component {
  render() {
    return (
      <div className="page">
        <div className="image">
          <Link to="/">
            <div className="ts-el">
              <span className="t">T</span>
              <span className="s">elephone Sound</span>
            </div>
            <div className="el">…</div>
            <img
              className="album-cover"
              src="./images/ellipsis-remastered-deluxe-album_cover.png"
              alt="A digitally modified photograph of clouds, taken from above."
            />
          </Link>
        </div>

        <div className="links">
          <h4>
            <Link to="/">Telephone Sound</Link> is an electronic music band from{" "}
            <a
              href="https://goo.gl/maps/68jtLij9kX72"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ottawa, Ontario, Canada
            </a>
            , consisting of partners{" "}
            <a
              href="https://prettyweird.ca"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fern Vale Volante
            </a>{" "}
            and{" "}
            <a
              href="https://eternalvoid.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jeremy Carter
            </a>
            .
          </h4>

          <a href="https://distrokid.com/hyperfollow/telephonesound/ellipsis-remastered-deluxe-2">
            <h3>
              Available now on all of your favourite music streaming services.
              More links will be added later, but it's probably already
              available so just check for it on the streaming platform.
            </h3>
          </a>

          <h2>Ellipsis (Remastered Deluxe), released in 2020:</h2>

          {/* <iframe title="Ellipsis (Remastered Deluxe) by Telephone Sound, embedded from Audius." src="https://audius.co/embed/album?id=46904&ownerId=167306&flavor=card" width="100%" height="480" allow="encrypted-media" style={{'border': 'none'}} /> */}
          {/* <iframe title="Ellipsis (Remastered Deluxe) by Telephone Sound, embedded from Audiomack." src="https://audiomack.com/embed/album/telephonesound/ellipsis-remastered-deluxe?background=1" scrolling="no" width="100%" height="400" scrollBars="no" frameBorder="0" /> */}
          {/* <iframe title="Ellipsis (Remastered Deluxe) by Telephone Sound, embedded from SoundCloud." width="100%" height="300" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1017678904&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true" target="_blank" rel="noopener noreferrer" /> */}
          <iframe
            title="Ellipsis (Remastered Deluxe) by Telephone Sound, embedded from YouTube."
            width="560"
            height="315"
            src="https://www.youtube-nocookie.com/embed/videoseries?list=OLAK5uy_n2ppYqCNO2K_sb3KJFWy5z7M5LoMtM4L4"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          <h3>
            <a
              href="https://defcronyke.github.io/ts-camera-filter"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here to try the Telephone Sound Audio-Reactive Camera
              Filter, you can use it with any device that has a screen, camera,
              and microphone attached. Visualize your surroundings with audio
              through this neat augmented reality web app.
            </a>{" "}
            <a
              href="https://github.com/defcronyke/ts-camera-filter"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here for the source code.
            </a>
          </h3>

          <ul>
            <li>
              <a
                href="https://emanate.live/telephonesound"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on Emanate.live
              </a>
            </li>
            <li>
              <a
                href="https://telephonesound.bandcamp.com/album/ellipsis-remastered-deluxe"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream or buy on BandCamp
              </a>
            </li>
            <li>
              <a
                href="https://music.youtube.com/playlist?list=OLAK5uy_nqH6DJzhIe3i-SUDm8Ex5S_r06qiLUZ-k"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on YouTube Music
              </a>
            </li>
            <li>
              <a
                href="https://play.google.com/store/music/album/Telephone_Sound_Ellipsis_Remastered_Deluxe?id=Be6uvln5i3jngnc7hfw6qhk7mui"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream or buy on Google Play Music Store
              </a>
            </li>
            {/* <li><a href="https://www.amazon.com/gp/product/B084RR3J81" target="_blank" rel="noopener noreferrer">Stream or buy on Amazon</a></li> */}
            <li>
              <a
                href="https://soundcloud.com/telephonesound/sets/ellipsis-remastered-deluxe"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream or download on SoundCloud
              </a>
            </li>
            <li>
              <a
                href="https://audiomack.com/album/telephonesound/ellipsis-remastered-deluxe"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on Audiomack
              </a>
            </li>
            {/* <li><a href="https://music.youtube.com/playlist?list=OLAK5uy_n2ppYqCNO2K_sb3KJFWy5z7M5LoMtM4L4" target="_blank" rel="noopener noreferrer">Stream on YouTube Music</a></li> */}
            {/* <li><a href="https://www.youtube.com/watch?v=R1ZclqJiIjs&list=OLAK5uy_n2ppYqCNO2K_sb3KJFWy5z7M5LoMtM4L4" target="_blank" rel="noopener noreferrer">Stream on YouTube</a></li> */}
            <li>
              <a
                href="https://open.spotify.com/album/4dDHYDQPaVzYEGLUAlvX6g"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on Spotify
              </a>
            </li>
            <li>
              <a
                href="https://music.apple.com/ca/album/ellipsis-remastered-deluxe-remastered/1498888685"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on Apple Music or Buy on iTunes
              </a>
            </li>
            <li>
              <a
                href="https://www.deezer.com/album/131566232"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream on Deezer
              </a>
            </li>
            {/* <li><a href="https://www.tidal.com/album/94767312" target="_blank" rel="noopener noreferrer">Stream on Tidal</a></li> */}
            {/* <li><a href="https://us.napster.com/artist/telephone-sound/album/ellipsis-deluxe" target="_blank" rel="noopener noreferrer">Stream on Napster</a></li> */}
            {/* <li><a href="https://www.kkbox.com/sg/en/album/wdKVeUJTvMSoj0F2MfQG009H-index.html" target="_blank" rel="noopener noreferrer">Stream on KKBox</a></li> */}
            <li>
              <a
                href="https://www.facebook.com/telephonesound"
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow our Facebook page
              </a>
            </li>
            <li>
              <a
                href="https://www.patreon.com/telephonesound"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support us on Patreon
              </a>
            </li>
            <li>
              Support us by sending an{" "}
              <a
                href="https://en.wikipedia.org/wiki/Interac_e-Transfer"
                target="_blank"
                rel="noopener noreferrer"
              >
                Interac eTransfer
              </a>{" "}
              or{" "}
              <a
                href="https://paypal.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                PayPal transfer
              </a>{" "}
              to:{" "}
              <a href="mailto:jeremy@jeremycarter.ca">jeremy@jeremycarter.ca</a>
            </li>
            <li>
              Support us by sending{" "}
              <a
                href="https://en.wikipedia.org/wiki/Bitcoin"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bitcoin
              </a>{" "}
              to BTC address:{" "}
              <a href="bitcoin:bc1quka4yv0tpfym8hpc34ljys0qfk92u5cljrfzxm?amount=0.0003">
                bc1quka4yv0tpfym8hpc34ljys0qfk92u5cljrfzxm
              </a>
            </li>
            <li>
              <a
                href="https://archive.org/details/telephone-sound-ellipsis-remastered-deluxe"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stream or download on Archive.org
              </a>
            </li>
          </ul>

          {/* <div className="news">
            <h2>News:</h2>
            <iframe
              title="Telephone Sound Ellipsis Remastered Deluxe Facebook Page Embed"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftelephonesound%2F&tabs=timeline%2Cmessages&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=191450255397229"
              width="340"
              height="500"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allowtransparency="true"
              allow="encrypted-media"
            />
          </div> */}

          <h3>
            Check out what we&#39;re working on for our next album. New tracks
            get posted to our{" "}
            <a
              href="https://audiomack.com/artist/telephonesound"
              target="_blank"
              rel="noopener noreferrer"
            >
              Audiomack
            </a>{" "}
            and{" "}
            <a
              href="https://soundcloud.com/telephonesound"
              target="_blank"
              rel="noopener noreferrer"
            >
              SoundCloud
            </a>{" "}
            while we&#39;re working on the next album:
          </h3>

          <iframe
            title="All songs by Telephone Sound, embedded from Audiomack."
            src="https://audiomack.com/embed/playlist/telephonesound/all?background=1"
            scrolling="no"
            width="100%"
            height="400"
            scrollbars="no"
            frameBorder="0"
          />
          {/* <iframe width="100%" height="450" scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/583796493&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"/> */}

          <h4>
            If you like this, check out{" "}
            <a
              href="https://www.youtube.com/watch?v=lQHezciPEDI"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fern&#39;s solo work here
            </a>
            , and{" "}
            <a
              href="https://eternalvoid.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jeremy
            </a>
            &#39;s side project Defcronyke:{" "}
            <a
              href="https://defcronyke.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              defcronyke.com
            </a>
          </h4>
          <h4>
            The source code for this website is available here:{" "}
            <a
              href="https://github.com/defcronyke/telephonesound"
              target="_blank"
              rel="noopener noreferrer"
            >
              github.com/defcronyke/telephonesound
            </a>
          </h4>
          <h4>
            Part of{" "}
            <a
              href="https://eternalvoid.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              The Eternal Void Network
            </a>
            .
          </h4>
          <p style={{ fontSize: "10pt" }}>
            <a href="privacy-policy.html">View Privacy Policy</a>
          </p>
          <br />
        </div>
      </div>
    );
  }
}
